var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"type":_vm.type,"underline":_vm.underline,"disabled":_vm.disabled,"href":_vm.href,"icon":_vm.icon}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }